import React from 'react';
import Icon from '../../../components/AppIcon';

const AvailabilityStats = ({ stats }) => {
  const getPercentage = (value, total) => {
    return total > 0 ? Math.round((value / total) * 100) : 0;
  };

  const statCards = [
    {
      label: 'Total de Lotes',
      value: stats?.total,
      icon: 'Grid3x3',
      color: 'primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Disponibles',
      value: stats?.available,
      percentage: getPercentage(stats?.available, stats?.total),
      icon: 'CheckCircle2',
      color: 'success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Reservados',
      value: stats?.reserved,
      percentage: getPercentage(stats?.reserved, stats?.total),
      icon: 'Clock',
      color: 'warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Vendidos',
      value: stats?.sold,
      percentage: getPercentage(stats?.sold, stats?.total),
      icon: 'ShoppingCart',
      color: 'error',
      bgColor: 'bg-error/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card rounded-xl shadow-lg p-4 md:p-6">
          <div className="flex items-start justify-between mb-4">
            <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} color={`var(--color-${stat?.color})`} />
            </div>
            {stat?.percentage !== undefined && (
              <span className={`text-xs md:text-sm font-medium text-${stat?.color}`}>
                {stat?.percentage}%
              </span>
            )}
          </div>
          <div className="text-2xl md:text-3xl font-bold mb-1">{stat?.value}</div>
          <div className="text-xs md:text-sm text-muted-foreground">{stat?.label}</div>
        </div>
      ))}
    </div>
  );
};

export default AvailabilityStats;